/**
 * Created by Victor Rojo on 2/12/19.
 */
import { Component, TemplateRef, ViewChild, OnDestroy }     from '@angular/core';
import {PetrolDiscountTransactionService} from "./PetrolDiscountTransaction.service";
import {PetrolDiscountTransaction} from "./PetrolDiscountTransaction";
import {I18NService} from "../../shared/i18n/i18n.service";

import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

import { interval ,  Unsubscribable as AnonymousSubscription }             from "rxjs";

@Component({
  templateUrl: './PetrolDiscountTransaction.component.html',
  styleUrls: ['./PetrolDiscountTransaction.component.css']
})
export class PetrolDiscountTransactionComponent implements OnDestroy{

  page: any;
  sort = 'createdAt,desc';
  sorts = [{prop: 'createdAt', dir: 'desc'}];
  isLoading = false;
  tableMessages: any;
  rows: PetrolDiscountTransaction[] = [];
  dateRangeFilter:any;
  bsConfig: Partial<BsDatepickerConfig>;
  petrolDiscountTransaction: PetrolDiscountTransaction;
  modalRef: BsModalRef;
  @ViewChild('detailTemplate', { static: true })
  private detailTempRef : TemplateRef<any>;
  private interval: AnonymousSubscription;

  constructor(private petrolDiscountTransactionService: PetrolDiscountTransactionService,
              private modalService: BsModalService,
              private i18nService: I18NService) {

    this.page = {
      count: 0,
      pageSize: 15,
      offset: 0,
    };

    let startDate = new Date();
    startDate.setHours(23,59,59,999);
    let endDate = new Date();
    endDate.setHours(0,0,0,0);
    endDate = new Date(endDate.getTime() - 604800000);
    this.dateRangeFilter = [endDate, startDate];

    this.tableMessages = {};
    this.tableMessages.emptyMessage = this.i18nService.get("noDataToDisplay");
    this.tableMessages.totalMessage = this.i18nService.get("total");
    this.tableMessages.selectedMessage = this.i18nService.get("selected");

    this.bsConfig = Object.assign({}, {containerClass: "theme-custom", showWeekNumbers: false});

    this.setPage(this.page);

    this.interval = interval(60000).subscribe(() => {
      this.page.pageSize += 1;
      this.setPage(this.page);
    });

  }

  onDateRangeChange(any:any){
    this.page.pageSize = 15;
    this.page.offset = 0;
    this.setPage(this.page);
  }

  setPage(pageInfo:any){
    this.isLoading = true;
    let filter = "";
    if ( this.dateRangeFilter && this.dateRangeFilter.length == 2 ) {
      filter =  "createdAt:>=:" + this.dateRangeFilter[0].getTime() + ":T;createdAt:<:" + (this.dateRangeFilter[1].getTime() + 86400000)+ ":T";
    }

    this.petrolDiscountTransactionService.getPage(pageInfo.offset,pageInfo.pageSize -1,this.sort, filter)
      .then( response => {
        this.isLoading = false;
        let sort = response.sort ? response.sort[0].property + "," + response.sort[0].direction : "";
        this.page = {
          count: response.totalElements,
          pageSize: response.size,
          offset: response.number
        };
        this.rows = response.content;
        this.rows.forEach(record => {
          record["createdDate"] = new Date(record.createdAt);
        });
        this.sorts = [{prop: response.sort[0].property, dir: response.sort[0].direction.toLowerCase()}];
      })
      .catch( error => {
        this.isLoading = false;
      });
  }

  onActivate(event: any) {
    if ( event.type == 'click' && event.column.prop) {
      this.petrolDiscountTransaction = event.row;

      this.modalRef = this.modalService.show(this.detailTempRef);
    }
  }

  onSort(event:any) {
    let prop = event.sorts[0].prop;
    this.sort = prop + "," + event.sorts[0].dir;
    this.page.pageSize += 1;
    this.setPage(this.page);
  }

  reload(){
    this.page.pageSize += 1;
    this.setPage(this.page);
  }

  hide() {
    this.modalService.hide(1);
  }

  public ngOnDestroy(): void {
    if ( this.interval ) {
      this.interval.unsubscribe()
    }
  }



}
